var items = {
  "block.minecraft.air": "aero",
  "block.minecraft.stone": "ŝtono",
  "block.minecraft.granite": "granito",
  "block.minecraft.polished_granite": "polurita granito",
  "block.minecraft.diorite": "diorito",
  "block.minecraft.polished_diorite": "polurita diorito",
  "block.minecraft.andesite": "andezito",
  "block.minecraft.polished_andesite": "polurita andezito",
  "block.minecraft.grass_block": "herba bloko",
  "block.minecraft.dirt": "tero",
  "block.minecraft.coarse_dirt": "maldelikata tero",
  "block.minecraft.podzol": "podzolo",
  "block.minecraft.crimson_nylium": "skarlata nilio",
  "block.minecraft.warped_nylium": "torda nilio",
  "block.minecraft.cobblestone": "pavimŝtono",
  "block.minecraft.oak_planks": "kverka tabularo",
  "block.minecraft.spruce_planks": "picea tabularo",
  "block.minecraft.birch_planks": "betula tabularo",
  "block.minecraft.jungle_planks": "ĝangalarba tabularo",
  "block.minecraft.acacia_planks": "akacia tabularo",
  "block.minecraft.dark_oak_planks": "malhelkverka tabularo",
  "block.minecraft.crimson_planks": "skarlata tabularo",
  "block.minecraft.warped_planks": "torda tabularo",
  "block.minecraft.oak_sapling": "kverkido",
  "block.minecraft.spruce_sapling": "piceido",
  "block.minecraft.birch_sapling": "betulido",
  "block.minecraft.jungle_sapling": "ĝangalarbido",
  "block.minecraft.acacia_sapling": "akaciido",
  "block.minecraft.dark_oak_sapling": "malhelkverkido",
  "block.minecraft.bedrock": "bazroko",
  "block.minecraft.sand": "sablo",
  "block.minecraft.red_sand": "ruĝa sablo",
  "block.minecraft.gravel": "gruzo",
  "block.minecraft.gold_ore": "ora erco",
  "block.minecraft.iron_ore": "fera erco",
  "block.minecraft.coal_ore": "karba erco",
  "block.minecraft.nether_gold_ore": "submonda ora erco",
  "block.minecraft.oak_log": "kverka ŝtipo",
  "block.minecraft.spruce_log": "picea ŝtipo",
  "block.minecraft.birch_log": "betula ŝtipo",
  "block.minecraft.jungle_log": "ĝangalarba ŝtipo",
  "block.minecraft.acacia_log": "akacia ŝtipo",
  "block.minecraft.dark_oak_log": "malhelkverka ŝtipo",
  "block.minecraft.crimson_stem": "skarlata stipo",
  "block.minecraft.warped_stem": "torda stipo",
  "block.minecraft.stripped_oak_log": "senŝela kverka ŝtipo",
  "block.minecraft.stripped_spruce_log": "senŝela picea ŝtipo",
  "block.minecraft.stripped_birch_log": "senŝela betula ŝtipo",
  "block.minecraft.stripped_jungle_log": "senŝela ĝangalarba ŝtipo",
  "block.minecraft.stripped_acacia_log": "senŝela akacia ŝtipo",
  "block.minecraft.stripped_dark_oak_log": "senŝela malhelkverka ŝtipo",
  "block.minecraft.stripped_crimson_stem": "senŝela skarlata stipo",
  "block.minecraft.stripped_warped_stem": "senŝela torda stipo",
  "block.minecraft.stripped_oak_wood": "senŝela kverka ligno",
  "block.minecraft.stripped_spruce_wood": "senŝela picea ligno",
  "block.minecraft.stripped_birch_wood": "senŝela betula ligno",
  "block.minecraft.stripped_jungle_wood": "senŝela ĝangalarba ligno",
  "block.minecraft.stripped_acacia_wood": "senŝela akacia ligno",
  "block.minecraft.stripped_dark_oak_wood": "senŝela malhelkverka ligno",
  "block.minecraft.stripped_crimson_hyphae": "senŝela skarlata hifaro",
  "block.minecraft.stripped_warped_hyphae": "senŝela torda hifaro",
  "block.minecraft.oak_wood": "kverka ligno",
  "block.minecraft.spruce_wood": "picea ligno",
  "block.minecraft.birch_wood": "betula ligno",
  "block.minecraft.jungle_wood": "ĝangalarba ligno",
  "block.minecraft.acacia_wood": "akacia ligno",
  "block.minecraft.dark_oak_wood": "malhelkverka ligno",
  "block.minecraft.crimson_hyphae": "skarlata hifaro",
  "block.minecraft.warped_hyphae": "torda hifaro",
  "block.minecraft.oak_leaves": "kverka foliaro",
  "block.minecraft.spruce_leaves": "picea foliaro",
  "block.minecraft.birch_leaves": "betula foliaro",
  "block.minecraft.jungle_leaves": "ĝangalarba foliaro",
  "block.minecraft.acacia_leaves": "akacia foliaro",
  "block.minecraft.dark_oak_leaves": "malhelkverka foliaro",
  "block.minecraft.sponge": "spongo",
  "block.minecraft.wet_sponge": "malseka spongo",
  "block.minecraft.glass": "vitro",
  "block.minecraft.lapis_ore": "lazurita erco",
  "block.minecraft.lapis_block": "lazurita bloko",
  "block.minecraft.dispenser": "ĵetilo",
  "block.minecraft.sandstone": "sabloŝtono",
  "block.minecraft.chiseled_sandstone": "ĉizita sabloŝtono",
  "block.minecraft.cut_sandstone": "tranĉita sabloŝtono",
  "block.minecraft.note_block": "notbloko",
  "block.minecraft.powered_rail": "elektra relo",
  "block.minecraft.detector_rail": "detektila relo",
  "block.minecraft.sticky_piston": "adhera piŝto",
  "block.minecraft.cobweb": "araneaĵo",
  "block.minecraft.grass": "herbo",
  "block.minecraft.fern": "filiko",
  "block.minecraft.dead_bush": "mortinta arbusto",
  "block.minecraft.seagrass": "marherbo",
  "block.minecraft.sea_pickle": "pirosomo",
  "block.minecraft.piston": "piŝto",
  "block.minecraft.white_wool": "blanka lano",
  "block.minecraft.orange_wool": "oranĝkolora lano",
  "block.minecraft.magenta_wool": "malva lano",
  "block.minecraft.light_blue_wool": "helblua lano",
  "block.minecraft.yellow_wool": "flava lano",
  "block.minecraft.lime_wool": "helverda lano",
  "block.minecraft.pink_wool": "rozkolora lano",
  "block.minecraft.gray_wool": "griza lano",
  "block.minecraft.light_gray_wool": "helgriza lano",
  "block.minecraft.cyan_wool": "turkisa lano",
  "block.minecraft.purple_wool": "violkolora lano",
  "block.minecraft.blue_wool": "blua lano",
  "block.minecraft.brown_wool": "bruna lano",
  "block.minecraft.green_wool": "verda lano",
  "block.minecraft.red_wool": "ruĝa lano",
  "block.minecraft.black_wool": "nigra lano",
  "block.minecraft.dandelion": "leontodo",
  "block.minecraft.poppy": "papaveto",
  "block.minecraft.blue_orchid": "blua orkido",
  "block.minecraft.allium": "aliumo",
  "block.minecraft.azure_bluet": "blua houstonio",
  "block.minecraft.red_tulip": "ruĝa tulipo",
  "block.minecraft.orange_tulip": "oranĝkolora tulipo",
  "block.minecraft.white_tulip": "blanka tulipo",
  "block.minecraft.pink_tulip": "rozkolora tulipo",
  "block.minecraft.oxeye_daisy": "lekanto",
  "block.minecraft.cornflower": "cejano",
  "block.minecraft.lily_of_the_valley": "konvalo",
  "block.minecraft.wither_rose": "vizerrozo",
  "block.minecraft.brown_mushroom": "boleto",
  "block.minecraft.red_mushroom": "muŝfungo",
  "block.minecraft.crimson_fungus": "skarlata fungo",
  "block.minecraft.warped_fungus": "torda fungo",
  "block.minecraft.crimson_roots": "skarlata radikaro",
  "block.minecraft.warped_roots": "torda radikaro",
  "block.minecraft.nether_sprouts": "submonda ŝoso",
  "block.minecraft.weeping_vines": "larmanta hedero",
  "block.minecraft.twisting_vines": "serpentanta hedero",
  "block.minecraft.sugar_cane": "sukerkano",
  "block.minecraft.kelp": "algo",
  "block.minecraft.bamboo": "bambuo",
  "block.minecraft.gold_block": "ora bloko",
  "block.minecraft.iron_block": "fera bloko",
  "block.minecraft.oak_slab": "kverka ŝtupo",
  "block.minecraft.spruce_slab": "picea ŝtupo",
  "block.minecraft.birch_slab": "betula ŝtupo",
  "block.minecraft.jungle_slab": "ĝangalarba ŝtupo",
  "block.minecraft.acacia_slab": "akacia ŝtupo",
  "block.minecraft.dark_oak_slab": "malhelkverka ŝtupo",
  "block.minecraft.crimson_slab": "skarlata ŝtupo",
  "block.minecraft.warped_slab": "torda ŝtupo",
  "block.minecraft.stone_slab": "ŝtona ŝtupo",
  "block.minecraft.smooth_stone_slab": "glata ŝtona ŝtupo",
  "block.minecraft.sandstone_slab": "sabloŝtona ŝtupo",
  "block.minecraft.cut_sandstone_slab": "tranĉita sabloŝtona ŝtupo",
  "block.minecraft.petrified_oak_slab": "ŝtoniĝita kverka ŝtupo",
  "block.minecraft.cobblestone_slab": "pavimŝtona ŝtupo",
  "block.minecraft.brick_slab": "brika ŝtupo",
  "block.minecraft.stone_brick_slab": "ŝtonbrika ŝtupo",
  "block.minecraft.nether_brick_slab": "submondbrika ŝtupo",
  "block.minecraft.quartz_slab": "kvarca ŝtupo",
  "block.minecraft.red_sandstone_slab": "ruĝa sabloŝtona ŝtupo",
  "block.minecraft.cut_red_sandstone_slab": "tranĉita ruĝa sabloŝtona ŝtupo",
  "block.minecraft.purpur_slab": "purpura ŝtupo",
  "block.minecraft.prismarine_slab": "prismarina ŝtupo",
  "block.minecraft.prismarine_brick_slab": "prismarinbrika ŝtupo",
  "block.minecraft.dark_prismarine_slab": "malhelprismarina ŝtupo",
  "block.minecraft.smooth_quartz": "glata kvarca bloko",
  "block.minecraft.smooth_red_sandstone": "glata ruĝa sabloŝtono",
  "block.minecraft.smooth_sandstone": "glata sabloŝtono",
  "block.minecraft.smooth_stone": "glata ŝtono",
  "block.minecraft.bricks": "brikaro",
  "block.minecraft.tnt": "tnt",
  "block.minecraft.bookshelf": "librobretaro",
  "block.minecraft.mossy_cobblestone": "muska pavimŝtono",
  "block.minecraft.obsidian": "obsidiano",
  "block.minecraft.torch": "torĉo",
  "block.minecraft.end_rod": "finejstango",
  "block.minecraft.chorus_plant": "refrena planto",
  "block.minecraft.chorus_flower": "refrena floro",
  "block.minecraft.purpur_block": "purpura bloko",
  "block.minecraft.purpur_pillar": "purpura kolono",
  "block.minecraft.purpur_stairs": "purpura ŝtuparo",
  "block.minecraft.spawner": "generilo",
  "block.minecraft.oak_stairs": "kverka ŝtuparo",
  "block.minecraft.chest": "kofro",
  "block.minecraft.diamond_ore": "diamanta erco",
  "block.minecraft.diamond_block": "diamanta bloko",
  "block.minecraft.crafting_table": "labortablo",
  "block.minecraft.farmland": "kultivtero",
  "block.minecraft.furnace": "forno",
  "block.minecraft.ladder": "ŝtupetaro",
  "block.minecraft.rail": "relo",
  "block.minecraft.cobblestone_stairs": "pavimŝtona ŝtuparo",
  "block.minecraft.lever": "levilo",
  "block.minecraft.stone_pressure_plate": "ŝtona premplato",
  "block.minecraft.oak_pressure_plate": "kverka premplato",
  "block.minecraft.spruce_pressure_plate": "picea premplato",
  "block.minecraft.birch_pressure_plate": "betula premplato",
  "block.minecraft.jungle_pressure_plate": "ĝangalarba premplato",
  "block.minecraft.acacia_pressure_plate": "akacia premplato",
  "block.minecraft.dark_oak_pressure_plate": "malhelkverka premplato",
  "block.minecraft.crimson_pressure_plate": "skarlata premplato",
  "block.minecraft.warped_pressure_plate": "torda premplato",
  "block.minecraft.polished_blackstone_pressure_plate": "polurita nigroŝtona premplato",
  "block.minecraft.redstone_ore": "ruĝona erco",
  "block.minecraft.redstone_torch": "ruĝona torĉo",
  "block.minecraft.snow": "neĝo",
  "block.minecraft.ice": "glacio",
  "block.minecraft.snow_block": "neĝa bloko",
  "block.minecraft.cactus": "kakto",
  "block.minecraft.clay": "argilbloko",
  "block.minecraft.jukebox": "muzikaŭtomato",
  "block.minecraft.oak_fence": "kverka barilo",
  "block.minecraft.spruce_fence": "picea barilo",
  "block.minecraft.birch_fence": "betula barilo",
  "block.minecraft.jungle_fence": "ĝangalarba barilo",
  "block.minecraft.acacia_fence": "akacia barilo",
  "block.minecraft.dark_oak_fence": "malhelkverka barilo",
  "block.minecraft.crimson_fence": "skarlata barilo",
  "block.minecraft.warped_fence": "torda barilo",
  "block.minecraft.pumpkin": "kukurbo",
  "block.minecraft.carved_pumpkin": "tajlita kukurbo",
  "block.minecraft.netherrack": "submondŝtono",
  "block.minecraft.soul_sand": "animsablo",
  "block.minecraft.soul_soil": "animtero",
  "block.minecraft.basalt": "bazalto",
  "block.minecraft.polished_basalt": "polurita bazalto",
  "block.minecraft.soul_torch": "anima torĉo",
  "block.minecraft.glowstone": "lumŝtono",
  "block.minecraft.jack_o_lantern": "kukurba lanterno",
  "block.minecraft.oak_trapdoor": "kverka klappordo",
  "block.minecraft.spruce_trapdoor": "picea klappordo",
  "block.minecraft.birch_trapdoor": "betula klappordo",
  "block.minecraft.jungle_trapdoor": "ĝangalarba klappordo",
  "block.minecraft.acacia_trapdoor": "akacia klappordo",
  "block.minecraft.dark_oak_trapdoor": "malhelkverka klappordo",
  "block.minecraft.crimson_trapdoor": "skarlata klappordo",
  "block.minecraft.warped_trapdoor": "torda klappordo",
  "block.minecraft.infested_stone": "infestita ŝtono",
  "block.minecraft.infested_cobblestone": "infestita pavimŝtono",
  "block.minecraft.infested_stone_bricks": "infestita ŝtona brikaro",
  "block.minecraft.infested_mossy_stone_bricks": "infestita muska ŝtona brikaro",
  "block.minecraft.infested_cracked_stone_bricks": "infestita rompita ŝtona brikaro",
  "block.minecraft.infested_chiseled_stone_bricks": "infestita ĉizita ŝtona brikaro",
  "block.minecraft.stone_bricks": "ŝtona brikaro",
  "block.minecraft.mossy_stone_bricks": "muska ŝtona brikaro",
  "block.minecraft.cracked_stone_bricks": "rompita ŝtona brikaro",
  "block.minecraft.chiseled_stone_bricks": "ĉizita ŝtona brikaro",
  "block.minecraft.brown_mushroom_block": "boleta bloko",
  "block.minecraft.red_mushroom_block": "muŝfunga bloko",
  "block.minecraft.mushroom_stem": "fungstipo",
  "block.minecraft.iron_bars": "fera krado",
  "block.minecraft.chain": "ĉeno",
  "block.minecraft.glass_pane": "glaco",
  "block.minecraft.melon": "akvomelono",
  "block.minecraft.vine": "liano",
  "block.minecraft.oak_fence_gate": "kverka barilpordo",
  "block.minecraft.spruce_fence_gate": "picea barilpordo",
  "block.minecraft.birch_fence_gate": "betula barilpordo",
  "block.minecraft.jungle_fence_gate": "ĝangalarba barilpordo",
  "block.minecraft.acacia_fence_gate": "akacia barilpordo",
  "block.minecraft.dark_oak_fence_gate": "malhelkverka barilpordo",
  "block.minecraft.crimson_fence_gate": "skarlata barilpordo",
  "block.minecraft.warped_fence_gate": "torda barilpordo",
  "block.minecraft.brick_stairs": "brika ŝtuparo",
  "block.minecraft.stone_brick_stairs": "ŝtonbrika ŝtuparo",
  "block.minecraft.mycelium": "micelio",
  "block.minecraft.lily_pad": "akvolilio",
  "block.minecraft.nether_bricks": "submonda brikaro",
  "block.minecraft.cracked_nether_bricks": "rompita submonda brikaro",
  "block.minecraft.chiseled_nether_bricks": "ĉizita submonda brikaro",
  "block.minecraft.nether_brick_fence": "submondbrika barilo",
  "block.minecraft.nether_brick_stairs": "submondbrika ŝtuparo",
  "block.minecraft.enchanting_table": "sorĉtablo",
  "block.minecraft.end_portal_frame": "kadro de finejportalo",
  "block.minecraft.end_stone": "finejŝtono",
  "block.minecraft.end_stone_bricks": "finejŝtona brikaro",
  "block.minecraft.dragon_egg": "draka ovo",
  "block.minecraft.redstone_lamp": "ruĝona lampo",
  "block.minecraft.sandstone_stairs": "sabloŝtona ŝtuparo",
  "block.minecraft.emerald_ore": "smeralda erco",
  "block.minecraft.ender_chest": "finejkofro",
  "block.minecraft.tripwire_hook": "hoko por insiddrato",
  "block.minecraft.emerald_block": "smeralda bloko",
  "block.minecraft.spruce_stairs": "picea ŝtuparo",
  "block.minecraft.birch_stairs": "betula ŝtuparo",
  "block.minecraft.jungle_stairs": "ĝangalarba ŝtuparo",
  "block.minecraft.crimson_stairs": "skarlata ŝtuparo",
  "block.minecraft.warped_stairs": "torda ŝtuparo",
  "block.minecraft.command_block": "komanda bloko",
  "block.minecraft.beacon": "lumstriilo",
  "block.minecraft.cobblestone_wall": "pavimŝtona muro",
  "block.minecraft.mossy_cobblestone_wall": "muska pavimŝtona muro",
  "block.minecraft.brick_wall": "brika muro",
  "block.minecraft.prismarine_wall": "prismarina muro",
  "block.minecraft.red_sandstone_wall": "ruĝa sabloŝtona muro",
  "block.minecraft.mossy_stone_brick_wall": "muska ŝtonbrika muro",
  "block.minecraft.granite_wall": "granita muro",
  "block.minecraft.stone_brick_wall": "ŝtonbrika muro",
  "block.minecraft.nether_brick_wall": "submondbrika muro",
  "block.minecraft.andesite_wall": "andezita muro",
  "block.minecraft.red_nether_brick_wall": "ruĝa submondbrika muro",
  "block.minecraft.sandstone_wall": "sabloŝtona muro",
  "block.minecraft.end_stone_brick_wall": "finejŝtonbrika muro",
  "block.minecraft.diorite_wall": "diorita muro",
  "block.minecraft.blackstone_wall": "nigroŝtona muro",
  "block.minecraft.polished_blackstone_wall": "polurita nigroŝtona muro",
  "block.minecraft.polished_blackstone_brick_wall": "polurita nigroŝtonbrika muro",
  "block.minecraft.stone_button": "ŝtona butono",
  "block.minecraft.oak_button": "kverka butono",
  "block.minecraft.spruce_button": "picea butono",
  "block.minecraft.birch_button": "betula butono",
  "block.minecraft.jungle_button": "ĝangalarba butono",
  "block.minecraft.acacia_button": "akacia butono",
  "block.minecraft.dark_oak_button": "malhelkverka butono",
  "block.minecraft.crimson_button": "skarlata butono",
  "block.minecraft.warped_button": "torda butono",
  "block.minecraft.polished_blackstone_button": "polurita nigroŝtona butono",
  "block.minecraft.anvil": "amboso",
  "block.minecraft.chipped_anvil": "fendiĝinta amboso",
  "block.minecraft.damaged_anvil": "damaĝita amboso",
  "block.minecraft.trapped_chest": "baskulkofro",
  "block.minecraft.light_weighted_pressure_plate": "malpeza premplato",
  "block.minecraft.heavy_weighted_pressure_plate": "peza premplato",
  "block.minecraft.daylight_detector": "taglumdetektilo",
  "block.minecraft.redstone_block": "ruĝona bloko",
  "block.minecraft.nether_quartz_ore": "kvarca erco",
  "block.minecraft.hopper": "funelo",
  "block.minecraft.chiseled_quartz_block": "ĉizita kvarca bloko",
  "block.minecraft.quartz_block": "kvarca bloko",
  "block.minecraft.quartz_bricks": "kvarca brikaro",
  "block.minecraft.quartz_pillar": "kvarca kolono",
  "block.minecraft.quartz_stairs": "kvarca ŝtuparo",
  "block.minecraft.activator_rail": "aktivigila relo",
  "block.minecraft.dropper": "donilo",
  "block.minecraft.white_terracotta": "blanka terakoto",
  "block.minecraft.orange_terracotta": "oranĝkolora terakoto",
  "block.minecraft.magenta_terracotta": "malva terakoto",
  "block.minecraft.light_blue_terracotta": "helblua terakoto",
  "block.minecraft.yellow_terracotta": "flava terakoto",
  "block.minecraft.lime_terracotta": "helverda terakoto",
  "block.minecraft.pink_terracotta": "rozkolora terakoto",
  "block.minecraft.gray_terracotta": "griza terakoto",
  "block.minecraft.light_gray_terracotta": "helgriza terakoto",
  "block.minecraft.cyan_terracotta": "turkisa terakoto",
  "block.minecraft.purple_terracotta": "violkolora terakoto",
  "block.minecraft.blue_terracotta": "blua terakoto",
  "block.minecraft.brown_terracotta": "bruna terakoto",
  "block.minecraft.green_terracotta": "verda terakoto",
  "block.minecraft.red_terracotta": "ruĝa terakoto",
  "block.minecraft.black_terracotta": "nigra terakoto",
  "block.minecraft.barrier": "barilego",
  "block.minecraft.iron_trapdoor": "fera klappordo",
  "block.minecraft.hay_block": "fojnpako",
  "block.minecraft.white_carpet": "blanka tapiŝo",
  "block.minecraft.orange_carpet": "oranĝkolora tapiŝo",
  "block.minecraft.magenta_carpet": "malva tapiŝo",
  "block.minecraft.light_blue_carpet": "helblua tapiŝo",
  "block.minecraft.yellow_carpet": "flava tapiŝo",
  "block.minecraft.lime_carpet": "helverda tapiŝo",
  "block.minecraft.pink_carpet": "rozkolora tapiŝo",
  "block.minecraft.gray_carpet": "griza tapiŝo",
  "block.minecraft.light_gray_carpet": "helgriza tapiŝo",
  "block.minecraft.cyan_carpet": "turkisa tapiŝo",
  "block.minecraft.purple_carpet": "violkolora tapiŝo",
  "block.minecraft.blue_carpet": "blua tapiŝo",
  "block.minecraft.brown_carpet": "bruna tapiŝo",
  "block.minecraft.green_carpet": "verda tapiŝo",
  "block.minecraft.red_carpet": "ruĝa tapiŝo",
  "block.minecraft.black_carpet": "nigra tapiŝo",
  "block.minecraft.terracotta": "terakoto",
  "block.minecraft.coal_block": "karba bloko",
  "block.minecraft.packed_ice": "fortika glacio",
  "block.minecraft.acacia_stairs": "akacia ŝtuparo",
  "block.minecraft.dark_oak_stairs": "malhelkverka ŝtuparo",
  "block.minecraft.slime_block": "mukbloko",
  "block.minecraft.grass_path": "herba pado",
  "block.minecraft.sunflower": "sunfloro",
  "block.minecraft.lilac": "siringo",
  "block.minecraft.rose_bush": "rozarbusto",
  "block.minecraft.peony": "peonio",
  "block.minecraft.tall_grass": "alta herbo",
  "block.minecraft.large_fern": "granda filiko",
  "block.minecraft.white_stained_glass": "blankigita vitro",
  "block.minecraft.orange_stained_glass": "oranĝkolorigita vitro",
  "block.minecraft.magenta_stained_glass": "malvigita vitro",
  "block.minecraft.light_blue_stained_glass": "helbluigita vitro",
  "block.minecraft.yellow_stained_glass": "flavigita vitro",
  "block.minecraft.lime_stained_glass": "helverdigita vitro",
  "block.minecraft.pink_stained_glass": "rozkolorigita vitro",
  "block.minecraft.gray_stained_glass": "grizigita vitro",
  "block.minecraft.light_gray_stained_glass": "helgrizigita vitro",
  "block.minecraft.cyan_stained_glass": "turkisigita vitro",
  "block.minecraft.purple_stained_glass": "violkolorigita vitro",
  "block.minecraft.blue_stained_glass": "bluigita vitro",
  "block.minecraft.brown_stained_glass": "brunigita vitro",
  "block.minecraft.green_stained_glass": "verdigita vitro",
  "block.minecraft.red_stained_glass": "ruĝigita vitro",
  "block.minecraft.black_stained_glass": "nigrigita vitro",
  "block.minecraft.white_stained_glass_pane": "blankigita glaco",
  "block.minecraft.orange_stained_glass_pane": "oranĝkolorigita glaco",
  "block.minecraft.magenta_stained_glass_pane": "malvigita glaco",
  "block.minecraft.light_blue_stained_glass_pane": "helbluigita glaco",
  "block.minecraft.yellow_stained_glass_pane": "flavigita glaco",
  "block.minecraft.lime_stained_glass_pane": "helverdigita glaco",
  "block.minecraft.pink_stained_glass_pane": "rozkolorigita glaco",
  "block.minecraft.gray_stained_glass_pane": "grizigita glaco",
  "block.minecraft.light_gray_stained_glass_pane": "helgrizigita glaco",
  "block.minecraft.cyan_stained_glass_pane": "turkisigita glaco",
  "block.minecraft.purple_stained_glass_pane": "violkolorigita glaco",
  "block.minecraft.blue_stained_glass_pane": "bluigita glaco",
  "block.minecraft.brown_stained_glass_pane": "brunigita glaco",
  "block.minecraft.green_stained_glass_pane": "verdigita glaco",
  "block.minecraft.red_stained_glass_pane": "ruĝigita glaco",
  "block.minecraft.black_stained_glass_pane": "nigrigita glaco",
  "block.minecraft.prismarine": "prismarino",
  "block.minecraft.prismarine_bricks": "prismarina brikaro",
  "block.minecraft.dark_prismarine": "malhelprismarino",
  "block.minecraft.prismarine_stairs": "prismarina ŝtuparo",
  "block.minecraft.prismarine_brick_stairs": "prismarinbrika ŝtuparo",
  "block.minecraft.dark_prismarine_stairs": "malhelprismarina ŝtuparo",
  "block.minecraft.sea_lantern": "marlanterno",
  "block.minecraft.red_sandstone": "ruĝa sabloŝtono",
  "block.minecraft.chiseled_red_sandstone": "ĉizita ruĝa sabloŝtono",
  "block.minecraft.cut_red_sandstone": "tranĉita ruĝa sabloŝtono",
  "block.minecraft.red_sandstone_stairs": "ruĝa sabloŝtona ŝtuparo",
  "block.minecraft.repeating_command_block": "ripeta komanda bloko",
  "block.minecraft.chain_command_block": "ĉena komanda bloko",
  "block.minecraft.magma_block": "magma bloko",
  "block.minecraft.nether_wart_block": "submondveruka bloko",
  "block.minecraft.warped_wart_block": "torda submondveruka bloko",
  "block.minecraft.red_nether_bricks": "ruĝa submonda brikaro",
  "block.minecraft.bone_block": "osta bloko",
  "block.minecraft.structure_void": "strukturvakuo",
  "block.minecraft.observer": "observilo",
  "block.minecraft.shulker_box": "skatolo de ŝulkro",
  "block.minecraft.white_shulker_box": "blanka skatolo de ŝulkro",
  "block.minecraft.orange_shulker_box": "oranĝkolora skatolo de ŝulkro",
  "block.minecraft.magenta_shulker_box": "malva skatolo de ŝulkro",
  "block.minecraft.light_blue_shulker_box": "helblua skatolo de ŝulkro",
  "block.minecraft.yellow_shulker_box": "flava skatolo de ŝulkro",
  "block.minecraft.lime_shulker_box": "helverda skatolo de ŝulkro",
  "block.minecraft.pink_shulker_box": "rozkolora skatolo de ŝulkro",
  "block.minecraft.gray_shulker_box": "griza skatolo de ŝulkro",
  "block.minecraft.light_gray_shulker_box": "helgriza skatolo de ŝulkro",
  "block.minecraft.cyan_shulker_box": "turkisa skatolo de ŝulkro",
  "block.minecraft.purple_shulker_box": "violkolora skatolo de ŝulkro",
  "block.minecraft.blue_shulker_box": "blua skatolo de ŝulkro",
  "block.minecraft.brown_shulker_box": "bruna skatolo de ŝulkro",
  "block.minecraft.green_shulker_box": "verda skatolo de ŝulkro",
  "block.minecraft.red_shulker_box": "ruĝa skatolo de ŝulkro",
  "block.minecraft.black_shulker_box": "nigra skatolo de ŝulkro",
  "block.minecraft.white_glazed_terracotta": "blanka glazurita terakoto",
  "block.minecraft.orange_glazed_terracotta": "oranĝkolora glazurita terakoto",
  "block.minecraft.magenta_glazed_terracotta": "malva glazurita terakoto",
  "block.minecraft.light_blue_glazed_terracotta": "helblua glazurita terakoto",
  "block.minecraft.yellow_glazed_terracotta": "flava glazurita terakoto",
  "block.minecraft.lime_glazed_terracotta": "helverda glazurita terakoto",
  "block.minecraft.pink_glazed_terracotta": "rozkolora glazurita terakoto",
  "block.minecraft.gray_glazed_terracotta": "griza glazurita terakoto",
  "block.minecraft.light_gray_glazed_terracotta": "helgriza glazurita terakoto",
  "block.minecraft.cyan_glazed_terracotta": "turkisa glazurita terakoto",
  "block.minecraft.purple_glazed_terracotta": "violkolora glazurita terakoto",
  "block.minecraft.blue_glazed_terracotta": "blua glazurita terakoto",
  "block.minecraft.brown_glazed_terracotta": "bruna glazurita terakoto",
  "block.minecraft.green_glazed_terracotta": "verda glazurita terakoto",
  "block.minecraft.red_glazed_terracotta": "ruĝa glazurita terakoto",
  "block.minecraft.black_glazed_terracotta": "nigra glazurita terakoto",
  "block.minecraft.white_concrete": "blanka betono",
  "block.minecraft.orange_concrete": "oranĝkolora betono",
  "block.minecraft.magenta_concrete": "malva betono",
  "block.minecraft.light_blue_concrete": "helblua betono",
  "block.minecraft.yellow_concrete": "flava betono",
  "block.minecraft.lime_concrete": "helverda betono",
  "block.minecraft.pink_concrete": "rozkolora betono",
  "block.minecraft.gray_concrete": "griza betono",
  "block.minecraft.light_gray_concrete": "helgriza betono",
  "block.minecraft.cyan_concrete": "turkisa betono",
  "block.minecraft.purple_concrete": "purpura betono",
  "block.minecraft.blue_concrete": "blua betono",
  "block.minecraft.brown_concrete": "bruna betono",
  "block.minecraft.green_concrete": "verda betono",
  "block.minecraft.red_concrete": "ruĝa betono",
  "block.minecraft.black_concrete": "nigra betono",
  "block.minecraft.white_concrete_powder": "blanka cemento",
  "block.minecraft.orange_concrete_powder": "oranĝkolora cemento",
  "block.minecraft.magenta_concrete_powder": "malva cemento",
  "block.minecraft.light_blue_concrete_powder": "helblua cemento",
  "block.minecraft.yellow_concrete_powder": "flava cemento",
  "block.minecraft.lime_concrete_powder": "helverda cemento",
  "block.minecraft.pink_concrete_powder": "rozkolora cemento",
  "block.minecraft.gray_concrete_powder": "griza cemento",
  "block.minecraft.light_gray_concrete_powder": "helgriza cemento",
  "block.minecraft.cyan_concrete_powder": "turkisa cemento",
  "block.minecraft.purple_concrete_powder": "violkolora cemento",
  "block.minecraft.blue_concrete_powder": "blua cemento",
  "block.minecraft.brown_concrete_powder": "bruna cemento",
  "block.minecraft.green_concrete_powder": "verda cemento",
  "block.minecraft.red_concrete_powder": "ruĝa cemento",
  "block.minecraft.black_concrete_powder": "nigra cemento",
  "block.minecraft.turtle_egg": "testudovo",
  "block.minecraft.dead_tube_coral_block": "mortinta bloko tubokorala",
  "block.minecraft.dead_brain_coral_block": "mortinta bloko cerbokorala",
  "block.minecraft.dead_bubble_coral_block": "mortinta bloko bobelokorala",
  "block.minecraft.dead_fire_coral_block": "mortinta bloko fajrokorala",
  "block.minecraft.dead_horn_coral_block": "mortinta bloko kornokorala",
  "block.minecraft.tube_coral_block": "bloko tubokorala",
  "block.minecraft.brain_coral_block": "bloko cerbokorala",
  "block.minecraft.bubble_coral_block": "bloko bobelokorala",
  "block.minecraft.fire_coral_block": "bloko fajrokorala",
  "block.minecraft.horn_coral_block": "bloko kornokorala",
  "block.minecraft.tube_coral": "tubokoralo",
  "block.minecraft.brain_coral": "cerbokoralo",
  "block.minecraft.bubble_coral": "bobelokoralo",
  "block.minecraft.fire_coral": "fajrokoralo",
  "block.minecraft.horn_coral": "kornokoralo",
  "block.minecraft.dead_brain_coral": "mortinta cerbokoralo",
  "block.minecraft.dead_bubble_coral": "mortinta bobelokoralo",
  "block.minecraft.dead_fire_coral": "mortinta fajrokoralo",
  "block.minecraft.dead_horn_coral": "mortinta kornokoralo",
  "block.minecraft.dead_tube_coral": "mortinta tubokoralo",
  "block.minecraft.tube_coral_fan": "ventumilo tubokorala",
  "block.minecraft.brain_coral_fan": "ventumilo cerbokorala",
  "block.minecraft.bubble_coral_fan": "ventumilo bobelokorala",
  "block.minecraft.fire_coral_fan": "ventumilo fajrokorala",
  "block.minecraft.horn_coral_fan": "ventumilo kornokorala",
  "block.minecraft.dead_tube_coral_fan": "mortinta ventumilo tubokorala",
  "block.minecraft.dead_brain_coral_fan": "mortinta ventumilo cerbokorala",
  "block.minecraft.dead_bubble_coral_fan": "mortinta ventumilo bobelokorala",
  "block.minecraft.dead_fire_coral_fan": "mortinta ventumilo fajrokorala",
  "block.minecraft.dead_horn_coral_fan": "mortinta ventumilo kornokorala",
  "block.minecraft.blue_ice": "glacio blua",
  "block.minecraft.conduit": "markondukto",
  "block.minecraft.polished_granite_stairs": "polurita granita ŝtuparo",
  "block.minecraft.smooth_red_sandstone_stairs": "glata ruĝa sabloŝtona ŝtuparo",
  "block.minecraft.mossy_stone_brick_stairs": "muska ŝtonbrika ŝtuparo",
  "block.minecraft.polished_diorite_stairs": "polurita diorita ŝtuparo",
  "block.minecraft.mossy_cobblestone_stairs": "muska pavimŝtona ŝtuparo",
  "block.minecraft.end_stone_brick_stairs": "finejŝtonbrika ŝtuparo",
  "block.minecraft.stone_stairs": "ŝtona ŝtuparo",
  "block.minecraft.smooth_sandstone_stairs": "glata sabloŝtona ŝtuparo",
  "block.minecraft.smooth_quartz_stairs": "glata kvarca ŝtuparo",
  "block.minecraft.granite_stairs": "granita ŝtuparo",
  "block.minecraft.andesite_stairs": "andezita ŝtuparo",
  "block.minecraft.red_nether_brick_stairs": "ruĝa submondbrika ŝtuparo",
  "block.minecraft.polished_andesite_stairs": "polurita andezita ŝtuparo",
  "block.minecraft.diorite_stairs": "diorita ŝtuparo",
  "block.minecraft.polished_granite_slab": "polurita granita ŝtupo",
  "block.minecraft.smooth_red_sandstone_slab": "glata ruĝa sabloŝtona ŝtupo",
  "block.minecraft.mossy_stone_brick_slab": "muska ŝtonbrika ŝtupo",
  "block.minecraft.polished_diorite_slab": "polurita diorita ŝtupo",
  "block.minecraft.mossy_cobblestone_slab": "muska pavimŝtona ŝtupo",
  "block.minecraft.end_stone_brick_slab": "finejŝtonbrika ŝtupo",
  "block.minecraft.smooth_sandstone_slab": "glata sabloŝtona ŝtupo",
  "block.minecraft.smooth_quartz_slab": "glata kvarca ŝtupo",
  "block.minecraft.granite_slab": "granita ŝtupo",
  "block.minecraft.andesite_slab": "andezita ŝtupo",
  "block.minecraft.red_nether_brick_slab": "ruĝa submondbrika ŝtupo",
  "block.minecraft.polished_andesite_slab": "polurita andezita ŝtupo",
  "block.minecraft.diorite_slab": "diorita ŝtupo",
  "block.minecraft.scaffolding": "skafaldo",
  "block.minecraft.iron_door": "fera pordo",
  "block.minecraft.oak_door": "kverka pordo",
  "block.minecraft.spruce_door": "picea pordo",
  "block.minecraft.birch_door": "betula pordo",
  "block.minecraft.jungle_door": "ĝangalarba pordo",
  "block.minecraft.acacia_door": "akacia pordo",
  "block.minecraft.dark_oak_door": "malhelkverka pordo",
  "block.minecraft.crimson_door": "skarlata pordo",
  "block.minecraft.warped_door": "torda pordo",
  "block.minecraft.repeater": "ruĝona ripetilo",
  "block.minecraft.comparator": "komparilo",
  "block.minecraft.structure_block": "strukturbloko",
  "block.minecraft.jigsaw": "konstruktbloko",
  "item.minecraft.turtle_helmet": "testuda ŝelo□□kiam sur kapo:□+2 kiraso",
  "item.minecraft.scute": "ŝelero",
  "item.minecraft.iron_shovel": "fera fosilo□□kiam en ĉefa mano:□+3.5 atakdamaĝo□-3 atakrapideco",
  "item.minecraft.iron_pickaxe": "fera pioĉo□□kiam en ĉefa mano:□+3 atakdamaĝo□-2.8 atakrapideco",
  "item.minecraft.iron_axe": "fera hakilo□□kiam en ĉefa mano:□+8 atakdamaĝo□-3.1 atakrapideco",
  "item.minecraft.flint_and_steel": "fajrilo",
  "item.minecraft.apple": "pomo",
  "item.minecraft.bow": "pafarko",
  "item.minecraft.arrow": "sago",
  "item.minecraft.coal": "karbo",
  "item.minecraft.charcoal": "lignokarbo",
  "item.minecraft.diamond": "diamanto",
  "item.minecraft.iron_ingot": "fera ingoto",
  "item.minecraft.gold_ingot": "ora ingoto",
  "item.minecraft.netherite_ingot": "subena ingoto",
  "item.minecraft.netherite_scrap": "subena fragmento",
  "item.minecraft.iron_sword": "fera glavo□□kiam en ĉefa mano:□+5 atakdamaĝo□-2.4 atakrapideco",
  "item.minecraft.wooden_sword": "ligna glavo□□kiam en ĉefa mano:□+3 atakdamaĝo□-2.4 atakrapideco",
  "item.minecraft.wooden_shovel": "ligna fosilo□□kiam en ĉefa mano:□+1.5 atakdamaĝo□-3 atakrapideco",
  "item.minecraft.wooden_pickaxe": "ligna pioĉo□□kiam en ĉefa mano:□+1 atakdamaĝo□-2.8 atakrapideco",
  "item.minecraft.wooden_axe": "ligna hakilo□□kiam en ĉefa mano:□+6 atakdamaĝo□-3.2 atakrapideco",
  "item.minecraft.stone_sword": "ŝtona glavo□□kiam en ĉefa mano:□+4 atakdamaĝo□-2.4 atakrapideco",
  "item.minecraft.stone_shovel": "ŝtona fosilo□□kiam en ĉefa mano:□+2.5 atakdamaĝo□-3 atakrapideco",
  "item.minecraft.stone_pickaxe": "ŝtona pioĉo□□kiam en ĉefa mano:□+2 atakdamaĝo□-2.8 atakrapideco",
  "item.minecraft.stone_axe": "ŝtona hakilo□□kiam en ĉefa mano:□+8 atakdamaĝo□-3.2 atakrapideco",
  "item.minecraft.diamond_sword": "diamanta glavo□□kiam en ĉefa mano:□+6 atakdamaĝo□-2.4 atakrapideco",
  "item.minecraft.diamond_shovel": "diamanta fosilo□□kiam en ĉefa mano:□+4.5 atakdamaĝo□-3 atakrapideco",
  "item.minecraft.diamond_pickaxe": "diamanta pioĉo□□kiam en ĉefa mano:□+4 atakdamaĝo□-2.8 atakrapideco",
  "item.minecraft.diamond_axe": "diamanta hakilo□□kiam en ĉefa mano:□+8 atakdamaĝo□-3 atakrapideco",
  "item.minecraft.stick": "bastono",
  "item.minecraft.bowl": "bovlo",
  "item.minecraft.mushroom_stew": "fungosupo",
  "item.minecraft.golden_sword": "ora glavo□□kiam en ĉefa mano:□+3 atakdamaĝo□-2.4 atakrapideco",
  "item.minecraft.golden_shovel": "ora fosilo□□kiam en ĉefa mano:□+1.5 atakdamaĝo□-3 atakrapideco",
  "item.minecraft.golden_pickaxe": "ora pioĉo□□kiam en ĉefa mano:□+1 atakdamaĝo□-2.8 atakrapideco",
  "item.minecraft.golden_axe": "ora hakilo□□kiam en ĉefa mano:□+6 atakdamaĝo□-3 atakrapideco",
  "item.minecraft.netherite_sword": "subena glavo□□kiam en ĉefa mano:□+7 atakdamaĝo□-2.4 atakrapideco",
  "item.minecraft.netherite_shovel": "subena fosilo□□kiam en ĉefa mano:□+5.5 atakdamaĝo□-3 atakrapideco",
  "item.minecraft.netherite_pickaxe": "subena pioĉo□□kiam en ĉefa mano:□+5 atakdamaĝo□-2.8 atakrapideco",
  "item.minecraft.netherite_axe": "subena hakilo□□kiam en ĉefa mano:□+9 atakdamaĝo□-3 atakrapideco",
  "item.minecraft.string": "fadeno",
  "item.minecraft.feather": "plumo",
  "item.minecraft.gunpowder": "pulvo",
  "item.minecraft.wooden_hoe": "ligna sarkilo□□kiam en ĉefa mano:□-3 atakrapideco",
  "item.minecraft.stone_hoe": "ŝtona sarkilo□□kiam en ĉefa mano:□-2 atakrapideco",
  "item.minecraft.iron_hoe": "fera sarkilo□□kiam en ĉefa mano:□-1 atakrapideco",
  "item.minecraft.diamond_hoe": "diamanta sarkilo□□kiam en ĉefa mano:",
  "item.minecraft.golden_hoe": "ora sarkilo□□kiam en ĉefa mano:□-3 atakrapideco",
  "item.minecraft.netherite_hoe": "subena sarkilo□□kiam en ĉefa mano:",
  "item.minecraft.wheat_seeds": "tritikaj semoj",
  "item.minecraft.wheat": "tritiko",
  "item.minecraft.bread": "pano",
  "item.minecraft.leather_helmet": "leda ĉapo□□kiam sur kapo:□+1 kiraso",
  "item.minecraft.leather_chestplate": "leda tuniko□□kiam sur torso:□+3 kiraso",
  "item.minecraft.leather_leggings": "leda pantalono□□kiam sur kruroj:□+2 kiraso",
  "item.minecraft.leather_boots": "ledaj botoj□□kiam sur piedoj:□+1 kiraso",
  "item.minecraft.chainmail_helmet": "ĉena kasko□□kiam sur kapo:□+2 kiraso",
  "item.minecraft.chainmail_chestplate": "ĉena brustokiraso□□kiam sur torso:□+5 kiraso",
  "item.minecraft.chainmail_leggings": "ĉena pantalono□□kiam sur kruroj:□+4 kiraso",
  "item.minecraft.chainmail_boots": "ĉenaj botoj□□kiam sur piedoj:□+1 kiraso",
  "item.minecraft.iron_helmet": "fera kasko□□kiam sur kapo:□+2 kiraso",
  "item.minecraft.iron_chestplate": "fera brustokiraso□□kiam sur torso:□+6 kiraso",
  "item.minecraft.iron_leggings": "fera pantalono□□kiam sur kruroj:□+5 kiraso",
  "item.minecraft.iron_boots": "feraj botoj□□kiam sur piedoj:□+2 kiraso",
  "item.minecraft.diamond_helmet": "diamanta kasko□□kiam sur kapo:□+3 kiraso□+2 kirashardeco",
  "item.minecraft.diamond_chestplate": "diamanta brustokiraso□□kiam sur torso:□+8 kiraso□+2 kirashardeco",
  "item.minecraft.diamond_leggings": "diamanta pantalono□□kiam sur kruroj:□+6 kiraso□+2 kirashardeco",
  "item.minecraft.diamond_boots": "diamantaj botoj□□kiam sur piedoj:□+3 kiraso□+2 kirashardeco",
  "item.minecraft.golden_helmet": "ora kasko□□kiam sur kapo:□+2 kiraso",
  "item.minecraft.golden_chestplate": "ora brustokiraso□□kiam sur torso:□+5 kiraso",
  "item.minecraft.golden_leggings": "ora pantalono□□kiam sur kruroj:□+3 kiraso",
  "item.minecraft.golden_boots": "oraj botoj□□kiam sur piedoj:□+1 kiraso",
  "item.minecraft.netherite_helmet": "subena kasko□□kiam sur kapo:□+3 kiraso□+3 kirashardeco□+1 forpuŝrezisto",
  "item.minecraft.netherite_chestplate": "subena brustokiraso□□kiam sur torso:□+8 kiraso□+3 kirashardeco□+1 forpuŝrezisto",
  "item.minecraft.netherite_leggings": "subena pantalono□□kiam sur kruroj:□+6 kiraso□+3 kirashardeco□+1 forpuŝrezisto",
  "item.minecraft.netherite_boots": "subenaj botoj□□kiam sur piedoj:□+3 kiraso□+3 kirashardeco□+1 forpuŝrezisto",
  "item.minecraft.flint": "siliko",
  "item.minecraft.porkchop": "kruda porkaĵo",
  "item.minecraft.cooked_porkchop": "kuirita porkaĵo",
  "item.minecraft.painting": "pentraĵo",
  "item.minecraft.golden_apple": "ora pomo",
  "item.minecraft.enchanted_golden_apple": "sorĉita ora pomo",
  "block.minecraft.oak_sign": "kverka ŝildeto",
  "block.minecraft.spruce_sign": "picea ŝildeto",
  "block.minecraft.birch_sign": "betula ŝildeto",
  "block.minecraft.jungle_sign": "ĝangalarba ŝildeto",
  "block.minecraft.acacia_sign": "akacia ŝildeto",
  "block.minecraft.dark_oak_sign": "malhelkverka ŝildeto",
  "block.minecraft.crimson_sign": "skarlata ŝildeto",
  "block.minecraft.warped_sign": "torda ŝildeto",
  "item.minecraft.bucket": "sitelo",
  "item.minecraft.water_bucket": "sitelo da akvo",
  "item.minecraft.lava_bucket": "sitelo da lafo",
  "item.minecraft.minecart": "vagoneto",
  "item.minecraft.saddle": "selo",
  "item.minecraft.redstone": "ruĝona polvo",
  "item.minecraft.snowball": "neĝbulo",
  "item.minecraft.oak_boat": "kverka boato",
  "item.minecraft.leather": "ledo",
  "item.minecraft.milk_bucket": "sitelo da lakto",
  "item.minecraft.pufferfish_bucket": "sitelo kun pintfiŝo",
  "item.minecraft.salmon_bucket": "sitelo kun salmo",
  "item.minecraft.cod_bucket": "sitelo kun moruo",
  "item.minecraft.tropical_fish_bucket": "sitelo kun tropika fiŝo",
  "item.minecraft.brick": "briko",
  "item.minecraft.clay_ball": "argilbulo",
  "block.minecraft.dried_kelp_block": "sekigita alga bloko",
  "item.minecraft.paper": "papero",
  "item.minecraft.book": "libro",
  "item.minecraft.slime_ball": "mukbulo",
  "item.minecraft.chest_minecart": "vagoneto kun kofro",
  "item.minecraft.furnace_minecart": "vagoneto kun forno",
  "item.minecraft.egg": "ovo",
  "item.minecraft.compass": "kompaso",
  "item.minecraft.fishing_rod": "fiŝkaptilo",
  "item.minecraft.clock": "horloĝo",
  "item.minecraft.glowstone_dust": "lumpolvo",
  "item.minecraft.cod": "kruda moruo",
  "item.minecraft.salmon": "kruda salmo",
  "item.minecraft.tropical_fish": "tropika fiŝo",
  "item.minecraft.pufferfish": "pintfiŝo",
  "item.minecraft.cooked_cod": "kuirita moruo",
  "item.minecraft.cooked_salmon": "kuirita salmo",
  "item.minecraft.ink_sac": "inksako",
  "item.minecraft.red_dye": "ruĝa tinkturo",
  "item.minecraft.green_dye": "verda tinkturo",
  "item.minecraft.cocoa_beans": "kakao",
  "item.minecraft.lapis_lazuli": "lazurito",
  "item.minecraft.purple_dye": "violkolora tinkturo",
  "item.minecraft.cyan_dye": "turkisa tinkturo",
  "item.minecraft.light_gray_dye": "helgriza tinkturo",
  "item.minecraft.gray_dye": "griza tinkturo",
  "item.minecraft.pink_dye": "rozkolora tinkturo",
  "item.minecraft.lime_dye": "helverda tinkturo",
  "item.minecraft.yellow_dye": "flava tinkturo",
  "item.minecraft.light_blue_dye": "helblua tinkturo",
  "item.minecraft.magenta_dye": "malva tinkturo",
  "item.minecraft.orange_dye": "oranĝkolora tinkturo",
  "item.minecraft.bone_meal": "osta faruno",
  "item.minecraft.blue_dye": "blua tinkturo",
  "item.minecraft.brown_dye": "bruna tinkturo",
  "item.minecraft.black_dye": "nigra tinkturo",
  "item.minecraft.white_dye": "blanka tinkturo",
  "item.minecraft.bone": "osto",
  "item.minecraft.sugar": "sukero",
  "block.minecraft.cake": "torto",
  "block.minecraft.white_bed": "blanka lito",
  "block.minecraft.orange_bed": "oranĝkolora lito",
  "block.minecraft.magenta_bed": "malva lito",
  "block.minecraft.light_blue_bed": "helblua lito",
  "block.minecraft.yellow_bed": "flava lito",
  "block.minecraft.lime_bed": "helverda lito",
  "block.minecraft.pink_bed": "roza lito",
  "block.minecraft.gray_bed": "griza lito",
  "block.minecraft.light_gray_bed": "helgriza lito",
  "block.minecraft.cyan_bed": "turkisa lito",
  "block.minecraft.purple_bed": "viola lito",
  "block.minecraft.blue_bed": "blua lito",
  "block.minecraft.brown_bed": "bruna lito",
  "block.minecraft.green_bed": "verda lito",
  "block.minecraft.red_bed": "ruĝa lito",
  "block.minecraft.black_bed": "nigra lito",
  "item.minecraft.cookie": "kekso",
  "item.minecraft.filled_map": "mapo□#0",
  "item.minecraft.shears": "tondilo",
  "item.minecraft.melon_slice": "akvomelontranĉaĵo",
  "item.minecraft.dried_kelp": "sekigita algo",
  "item.minecraft.pumpkin_seeds": "kukurbaj semoj",
  "item.minecraft.melon_seeds": "akvomelonaj semoj",
  "item.minecraft.beef": "kruda bovaĵo",
  "item.minecraft.cooked_beef": "bifsteko",
  "item.minecraft.chicken": "kruda kokaĵo",
  "item.minecraft.cooked_chicken": "kuirita kokaĵo",
  "item.minecraft.rotten_flesh": "putra karno",
  "item.minecraft.ender_pearl": "finejperlo",
  "item.minecraft.blaze_rod": "incendia vergo",
  "item.minecraft.ghast_tear": "ĥasta larmo",
  "item.minecraft.gold_nugget": "orobulo",
  "item.minecraft.nether_wart": "submonda veruko",
  "item.minecraft.potion": "nefarebla eliksiro□neniu efiko",
  "item.minecraft.glass_bottle": "vitra botelo",
  "item.minecraft.spider_eye": "okulo de araneo",
  "item.minecraft.fermented_spider_eye": "fermentita okulo de araneo",
  "item.minecraft.blaze_powder": "incendia pulvoro",
  "item.minecraft.magma_cream": "magmokremo",
  "block.minecraft.brewing_stand": "eliksirfarilo",
  "block.minecraft.cauldron": "kaldrono",
  "item.minecraft.ender_eye": "finejokulo",
  "item.minecraft.glistering_melon_slice": "tranĉaĵo da brila akvomelono",
  "item.minecraft.bat_spawn_egg": "aperigovo de vesperto",
  "item.minecraft.bee_spawn_egg": "aperigovo de abelo",
  "item.minecraft.blaze_spawn_egg": "aperigovo de incendio",
  "item.minecraft.cat_spawn_egg": "aperigovo de kato",
  "item.minecraft.cave_spider_spawn_egg": "aperigovo de kavernaraneo",
  "item.minecraft.chicken_spawn_egg": "aperigovo de koko",
  "item.minecraft.cod_spawn_egg": "aperigovo de moruo",
  "item.minecraft.cow_spawn_egg": "aperigovo de bovo",
  "item.minecraft.creeper_spawn_egg": "aperigovo de kripero",
  "item.minecraft.dolphin_spawn_egg": "aperigovo de delfeno",
  "item.minecraft.donkey_spawn_egg": "aperigovo de azeno",
  "item.minecraft.drowned_spawn_egg": "aperigovo de droninto",
  "item.minecraft.elder_guardian_spawn_egg": "aperigovo de pragardisto",
  "item.minecraft.enderman_spawn_egg": "aperigovo de finejano",
  "item.minecraft.endermite_spawn_egg": "aperigovo de finejmito",
  "item.minecraft.evoker_spawn_egg": "aperigovo de alvokisto",
  "item.minecraft.fox_spawn_egg": "aperigovo de vulpo",
  "item.minecraft.ghast_spawn_egg": "aperigovo de ĥasto",
  "item.minecraft.guardian_spawn_egg": "aperigovo de gardisto",
  "item.minecraft.hoglin_spawn_egg": "aperigovo de hoglo",
  "item.minecraft.horse_spawn_egg": "aperigovo de ĉevalo",
  "item.minecraft.husk_spawn_egg": "aperigovo de sekulo",
  "item.minecraft.llama_spawn_egg": "aperigovo de lamo",
  "item.minecraft.magma_cube_spawn_egg": "aperigovo de magmokubo",
  "item.minecraft.mooshroom_spawn_egg": "aperigovo de fungobovo",
  "item.minecraft.mule_spawn_egg": "aperigovo de mulo",
  "item.minecraft.ocelot_spawn_egg": "aperigovo de oceloto",
  "item.minecraft.panda_spawn_egg": "aperigovo de pando",
  "item.minecraft.parrot_spawn_egg": "aperigovo de papago",
  "item.minecraft.phantom_spawn_egg": "aperigovo de fantomo",
  "item.minecraft.pig_spawn_egg": "aperigovo de porko",
  "item.minecraft.piglin_spawn_egg": "aperigovo de piglo",
  "item.minecraft.pillager_spawn_egg": "aperigovo de rabisto",
  "item.minecraft.polar_bear_spawn_egg": "aperigovo de blanka urso",
  "item.minecraft.pufferfish_spawn_egg": "aperigovo de pintfiŝo",
  "item.minecraft.rabbit_spawn_egg": "aperigovo de kuniklo",
  "item.minecraft.ravager_spawn_egg": "aperigovo de ruiniganto",
  "item.minecraft.salmon_spawn_egg": "aperigovo de salmo",
  "item.minecraft.sheep_spawn_egg": "aperigovo de ŝafo",
  "item.minecraft.shulker_spawn_egg": "aperigovo de ŝulkro",
  "item.minecraft.silverfish_spawn_egg": "aperigovo de lepismo",
  "item.minecraft.skeleton_spawn_egg": "aperigovo de skeleto",
  "item.minecraft.skeleton_horse_spawn_egg": "aperigovo de skeleta ĉevalo",
  "item.minecraft.slime_spawn_egg": "aperigovo de mukokubo",
  "item.minecraft.spider_spawn_egg": "aperigovo de araneo",
  "item.minecraft.squid_spawn_egg": "aperigovo de kalmaro",
  "item.minecraft.stray_spawn_egg": "aperigovo de devojiĝanto",
  "item.minecraft.strider_spawn_egg": "aperigovo de lafpaŝanto",
  "item.minecraft.trader_llama_spawn_egg": "aperigovo de vendista lamo",
  "item.minecraft.tropical_fish_spawn_egg": "aperigovo de tropika fiŝo",
  "item.minecraft.turtle_spawn_egg": "aperigovo de testudo",
  "item.minecraft.vex_spawn_egg": "aperigovo de molestulo",
  "item.minecraft.villager_spawn_egg": "aperigovo de vilaĝano",
  "item.minecraft.vindicator_spawn_egg": "aperigovo de praviganto",
  "item.minecraft.wandering_trader_spawn_egg": "aperigovo de vaganta vendisto",
  "item.minecraft.witch_spawn_egg": "aperigovo de sorĉistino",
  "item.minecraft.wither_skeleton_spawn_egg": "aperigovo de vizerskeleto",
  "item.minecraft.wolf_spawn_egg": "aperigovo de lupo",
  "item.minecraft.zoglin_spawn_egg": "aperigovo de zoglo",
  "item.minecraft.zombie_spawn_egg": "aperigovo de zombio",
  "item.minecraft.zombie_horse_spawn_egg": "aperigovo de zombia ĉevalo",
  "item.minecraft.zombie_villager_spawn_egg": "aperigovo de zombia vilaĝano",
  "item.minecraft.zombified_piglin_spawn_egg": "aperigovo de zombia piglo",
  "item.minecraft.experience_bottle": "botelo de sorĉado",
  "item.minecraft.fire_charge": "fajrobulo",
  "item.minecraft.writable_book": "libro kaj plumo",
  "item.minecraft.written_book": "skribita libro",
  "item.minecraft.emerald": "smeraldo",
  "item.minecraft.item_frame": "kadro",
  "block.minecraft.flower_pot": "florpoto",
  "item.minecraft.carrot": "karoto",
  "item.minecraft.potato": "terpomo",
  "item.minecraft.baked_potato": "bakita terpomo",
  "item.minecraft.poisonous_potato": "venena terpomo",
  "item.minecraft.map": "blanka mapo",
  "item.minecraft.golden_carrot": "ora karoto",
  "block.minecraft.skeleton_skull": "kranio de skeleto",
  "block.minecraft.wither_skeleton_skull": "kranio de vizerskeleto",
  "block.minecraft.player_head": "kapo de ludanto",
  "block.minecraft.zombie_head": "kapo de zombio",
  "block.minecraft.creeper_head": "kapo de kripero",
  "block.minecraft.dragon_head": "kapo de drako",
  "item.minecraft.carrot_on_a_stick": "fiŝkaptilo kun karoto",
  "item.minecraft.warped_fungus_on_a_stick": "fiŝkaptilo kun torda fungo",
  "item.minecraft.nether_star": "submonda stelo",
  "item.minecraft.pumpkin_pie": "kukurba pirogo",
  "item.minecraft.firework_rocket": "artfajraĵa raketo",
  "item.minecraft.firework_star": "artfajraĵa stelo",
  "item.minecraft.enchanted_book": "sorĉita libro",
  "item.minecraft.nether_brick": "submondbriko",
  "item.minecraft.quartz": "kvarco",
  "item.minecraft.tnt_minecart": "vagoneto kun tnt",
  "item.minecraft.hopper_minecart": "vagoneto kun funelo",
  "item.minecraft.prismarine_shard": "prismarina splito",
  "item.minecraft.prismarine_crystals": "prismarina kristalo",
  "item.minecraft.rabbit": "kruda kuniklaĵo",
  "item.minecraft.cooked_rabbit": "kuirita kuniklaĵo",
  "item.minecraft.rabbit_stew": "kuniklaĵa raguo",
  "item.minecraft.rabbit_foot": "kunikla piedo",
  "item.minecraft.rabbit_hide": "kunikla felo",
  "item.minecraft.armor_stand": "kirasa tenilo",
  "item.minecraft.iron_horse_armor": "fera ĉevala kiraso",
  "item.minecraft.golden_horse_armor": "ora ĉevala kiraso",
  "item.minecraft.diamond_horse_armor": "diamanta ĉevala kiraso",
  "item.minecraft.leather_horse_armor": "leda ĉevala kiraso",
  "item.minecraft.lead": "kondukilo",
  "item.minecraft.name_tag": "nomilo",
  "item.minecraft.command_block_minecart": "vagoneto kun komanda bloko",
  "item.minecraft.mutton": "kruda ŝafaĵo",
  "item.minecraft.cooked_mutton": "kuirita ŝafaĵo",
  "block.minecraft.white_banner": "blanka standardo",
  "block.minecraft.orange_banner": "oranĝkolora standardo",
  "block.minecraft.magenta_banner": "malva standardo",
  "block.minecraft.light_blue_banner": "helblua standardo",
  "block.minecraft.yellow_banner": "flava standardo",
  "block.minecraft.lime_banner": "helverda standardo",
  "block.minecraft.pink_banner": "rozkolora standardo",
  "block.minecraft.gray_banner": "griza standardo",
  "block.minecraft.light_gray_banner": "helgriza standardo",
  "block.minecraft.cyan_banner": "turkisa standardo",
  "block.minecraft.purple_banner": "violkolora standardo",
  "block.minecraft.blue_banner": "blua standardo",
  "block.minecraft.brown_banner": "bruna standardo",
  "block.minecraft.green_banner": "verda standardo",
  "block.minecraft.red_banner": "ruĝa standardo",
  "block.minecraft.black_banner": "nigra standardo",
  "item.minecraft.end_crystal": "finejkristalo",
  "item.minecraft.chorus_fruit": "refrena frukto",
  "item.minecraft.popped_chorus_fruit": "krevita refrena frukto",
  "item.minecraft.beetroot": "ruĝbeto",
  "item.minecraft.beetroot_seeds": "ruĝbetaj semoj",
  "item.minecraft.beetroot_soup": "barĉo",
  "item.minecraft.dragon_breath": "draka blovo",
  "item.minecraft.splash_potion": "ŝpruca nefarebla eliksiro□neniu efiko",
  "item.minecraft.spectral_arrow": "spektra sago",
  "item.minecraft.tipped_arrow": "nefarebla eliksira sago□neniu efiko",
  "item.minecraft.lingering_potion": "resta nefarebla eliksiro□neniu efiko",
  "item.minecraft.shield": "ŝildo",
  "item.minecraft.elytra": "elitroj",
  "item.minecraft.spruce_boat": "picea boato",
  "item.minecraft.birch_boat": "betula boato",
  "item.minecraft.jungle_boat": "ĝangalarba boato",
  "item.minecraft.acacia_boat": "akacia boato",
  "item.minecraft.dark_oak_boat": "malhelkverka boato",
  "item.minecraft.totem_of_undying": "totemo de senmorteco",
  "item.minecraft.shulker_shell": "ŝelo de ŝulkro",
  "item.minecraft.iron_nugget": "ferobulo",
  "item.minecraft.knowledge_book": "libro de sciado",
  "item.minecraft.debug_stick": "sencimiga bastono",
  "item.minecraft.music_disc_13": "sondisko□c418 - 13",
  "item.minecraft.music_disc_cat": "sondisko□c418 - cat",
  "item.minecraft.music_disc_blocks": "sondisko□c418 - blocks",
  "item.minecraft.music_disc_chirp": "sondisko□c418 - chirp",
  "item.minecraft.music_disc_far": "sondisko□c418 - far",
  "item.minecraft.music_disc_mall": "sondisko□c418 - mall",
  "item.minecraft.music_disc_mellohi": "sondisko□c418 - mellohi",
  "item.minecraft.music_disc_stal": "sondisko□c418 - stal",
  "item.minecraft.music_disc_strad": "sondisko□c418 - strad",
  "item.minecraft.music_disc_ward": "sondisko□c418 - ward",
  "item.minecraft.music_disc_11": "sondisko□c418 - 11",
  "item.minecraft.music_disc_wait": "sondisko□c418 - wait",
  "item.minecraft.music_disc_pigstep": "sondisko□leno rejn - pigstep",
  "item.minecraft.trident": "tridento□□kiam en ĉefa mano:□+8 atakdamaĝo□-2.9 atakrapideco",
  "item.minecraft.phantom_membrane": "fantoma membrano",
  "item.minecraft.nautilus_shell": "naŭtila konko",
  "item.minecraft.heart_of_the_sea": "kerno de la maro",
  "item.minecraft.crossbow": "arbalesto",
  "item.minecraft.suspicious_stew": "suspektinda manĝaĵo",
  "block.minecraft.loom": "teksilo",
  "item.minecraft.flower_banner_pattern": "standarda ŝablono□flora bildo",
  "item.minecraft.creeper_banner_pattern": "standarda ŝablono□kripera bildo",
  "item.minecraft.skull_banner_pattern": "standarda ŝablono□krania bildo",
  "item.minecraft.mojang_banner_pattern": "standarda ŝablono□simbolo",
  "item.minecraft.globe_banner_pattern": "standarda ŝablono□terkubo",
  "item.minecraft.piglin_banner_pattern": "standarda ŝablono□muzelo",
  "block.minecraft.composter": "kompoŝtujo",
  "block.minecraft.barrel": "barelo",
  "block.minecraft.smoker": "fumilo",
  "block.minecraft.blast_furnace": "altforno",
  "block.minecraft.cartography_table": "kartografitablo",
  "block.minecraft.fletching_table": "pafarktablo",
  "block.minecraft.grindstone": "akrigilo",
  "block.minecraft.lectern": "libropupitro",
  "block.minecraft.smithing_table": "fandtablo",
  "block.minecraft.stonecutter": "ŝtontranĉilo",
  "block.minecraft.bell": "sonorilo",
  "block.minecraft.lantern": "lanterno",
  "block.minecraft.soul_lantern": "anima lanterno",
  "item.minecraft.sweet_berries": "dolĉberoj",
  "block.minecraft.campfire": "tendarfajro",
  "block.minecraft.soul_campfire": "animtendarfajro",
  "block.minecraft.shroomlight": "lumfungo",
  "item.minecraft.honeycomb": "miela ĉelaro",
  "block.minecraft.bee_nest": "abelnesto",
  "block.minecraft.beehive": "abelujo",
  "item.minecraft.honey_bottle": "botelo da mielo",
  "block.minecraft.honey_block": "mielbloko",
  "block.minecraft.honeycomb_block": "mielĉelarbloko",
  "block.minecraft.lodestone": "magnetŝtono",
  "block.minecraft.netherite_block": "subena bloko",
  "block.minecraft.ancient_debris": "antikva rubo",
  "block.minecraft.target": "pafcelo",
  "block.minecraft.crying_obsidian": "plorobsidiano",
  "block.minecraft.blackstone": "nigroŝtono",
  "block.minecraft.blackstone_slab": "nigroŝtona ŝtupo",
  "block.minecraft.blackstone_stairs": "nigroŝtona ŝtuparo",
  "block.minecraft.gilded_blackstone": "orita nigroŝtono",
  "block.minecraft.polished_blackstone": "polurita nigroŝtono",
  "block.minecraft.polished_blackstone_slab": "polurita nigroŝtona ŝtupo",
  "block.minecraft.polished_blackstone_stairs": "polurita nigroŝtona ŝtuparo",
  "block.minecraft.chiseled_polished_blackstone": "ĉizita polurita nigroŝtono",
  "block.minecraft.polished_blackstone_bricks": "polurita nigroŝtona brikaro",
  "block.minecraft.polished_blackstone_brick_slab": "polurita nigroŝtonbrika ŝtupo",
  "block.minecraft.polished_blackstone_brick_stairs": "polurita nigroŝtonbrika ŝtuparo",
  "block.minecraft.cracked_polished_blackstone_bricks": "rompita polurita nigroŝtona brikaro",
  "block.minecraft.respawn_anchor": "reaperankro",
}
export const eo_uy = items; 
